import type { FC, ReactNode } from 'react';
import { contactUsEmail } from '../util/constants';

export const FALLBACK_ERROR = '__FALLBACK_ERROR__';

const FallbackMessage: FC = () => (
  <>
    Something went wrong. Please contact system{' '}
    <a href={`mailto:${contactUsEmail}`}>support</a>.
  </>
);

interface ApiErrorMessageProps {
  message: string | null;
  onClose?: () => void;
  className?: string;
}

const ApiErrorMessage: FC<ApiErrorMessageProps> = ({ message, onClose, className = '' }) => {
  if (!message) return null;

  const content: ReactNode = message === FALLBACK_ERROR ? <FallbackMessage /> : message;

  return (
    <div className={`alert alert-danger alert-dismissible fade show ${className}`.trim()} role="alert">
      <i className="bi bi-exclamation-triangle-fill me-2"></i>
      {content}
      {onClose && (
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Close"
        ></button>
      )}
    </div>
  );
};

export default ApiErrorMessage;
